import imageCompression from "browser-image-compression";

/**
 * Compress an image file
 */
export const compressImage = async (file) => {
  const options = {
    maxSizeMB: 1, // Maximum size in MB
    maxWidthOrHeight: 1920, // Maximum width or height
    useWebWorker: true, // Use web worker for better performance
    fileType: file.type || "image/jpeg", // Maintain original type or default to JPEG
  };

  try {
    const compressedFile = await imageCompression(file, options);
    console.log(
      "Original image size:",
      (file.size / 1024 / 1024).toFixed(2),
      "MB"
    );
    console.log(
      "Compressed image size:",
      (compressedFile.size / 1024 / 1024).toFixed(2),
      "MB"
    );
    return compressedFile;
  } catch (error) {
    console.error("Image compression error:", error);
    // If compression fails, return original file
    return file;
  }
};

/**
 * Compress audio file (basic - just validates and returns original)
 * Note: True audio compression requires server-side processing or heavy libraries
 */
export const compressAudio = async (file) => {
  // For now, just return the original file
  // Audio compression typically requires server-side processing
  // or libraries like lamejs for MP3 encoding
  console.log("Audio file size:", (file.size / 1024 / 1024).toFixed(2), "MB");
  
  // If file is too large, we could show a warning
  const maxSizeMB = 50; // 50MB limit
  if (file.size > maxSizeMB * 1024 * 1024) {
    console.warn(`Audio file is large (${(file.size / 1024 / 1024).toFixed(2)}MB). Consider compressing it server-side.`);
  }
  
  return file;
};

/**
 * Compress video file (basic - just validates and returns original)
 * Note: True video compression requires server-side processing or ffmpeg.wasm
 */
export const compressVideo = async (file) => {
  // For now, just return the original file
  // Video compression typically requires server-side processing
  // or heavy client-side libraries like ffmpeg.wasm
  console.log("Video file size:", (file.size / 1024 / 1024).toFixed(2), "MB");
  
  // If file is too large, we could show a warning
  const maxSizeMB = 500; // 500MB limit
  if (file.size > maxSizeMB * 1024 * 1024) {
    console.warn(`Video file is large (${(file.size / 1024 / 1024).toFixed(2)}MB). Consider compressing it server-side.`);
  }
  
  return file;
};

/**
 * Compress file based on its type
 */
export const compressFile = async (file, type) => {
  if (type === "image" || file.type.startsWith("image/")) {
    return await compressImage(file);
  } else if (type === "audio" || file.type.startsWith("audio/")) {
    return await compressAudio(file);
  } else if (type === "video" || file.type.startsWith("video/")) {
    return await compressVideo(file);
  }
  // For other file types, return as-is
  return file;
};
